import HamQuest from '../../api/HamQuestGiver';
import { QuestRoute } from '../../api/QuestRoutes';
import CheckMark from '../../CheckMark';
import Button from '../../forms/Button';
import GetState from '../../GetState';
import ModalFactory from '../../Modal';
import AssignPlateReadAwardForm from '../../processors/AssignPlateReadAwardForm';
import RequireFeature, { Features } from '../../RequireFeature';
import { userRoles } from '../../RoleProtected';
import ManagementRow from '../../table/ManagementRow';
import Table, { Ctd } from '../../table/Table';
import { generateId, shortHandDateTimeUTC, shortHandDate } from '../../utility/functions';

const CustomerPlateReadAwards = ({ plate, isCustomer, ...props }) => {   
    const [customerPlateAwardsList, refreshAwardsList] = GetState(QuestRoute.plateReads.customerAwards(plate))
    
    const renderActionButtons = (e) => {
        var r = [];
        if(!e.redeemed && (!e.dateViewed || e.dateViewed === ''))
        {
            r.push(<Button roles={userRoles.editProducts} key={generateId()} onClick={()=> deletePlateAward(e)} icon='trash'>Delete</Button>);

        }
        return r
    }
    
    const addPlateAward = () => {
        let id = generateId();

        if(!plate && isCustomer)
        {
            ModalFactory.show({
                id,
                title: 'Assign Plate Read Award',
                type: 'error',
                body: (<>Customer plate information is missing or invalid.<br />Please ensure primary license plate media has been configured and is active status.</>)

            });
        }
        else 
        {            
            ModalFactory.show({
                id,
                title: 'Assign Plate Read Award',
                body: <AssignPlateReadAwardForm modalId={id} platesList={[plate]} callback={() => refreshAwardsList()} />
                
            });            
        }
    }    

    const deletePlateAward = (award) => {
        ModalFactory.confirmAndProcess({
            confirmation: {
                title: `Are you sure?`,
                body: `Are you sure you want to delete this award?`,
                type: 'warning',
            },
            promise: {
                title: 'Deleting Award.',
                body: `Deleting award for customer.`,
                callback: () => HamQuest.delete(QuestRoute.plateReads.awards(award.plateAwardId))
            },
            confirmed: {
                title: 'Success',
                body: `Award successfully deleted.`,
                type: 'success'
            },
            finally: () => refreshAwardsList()
        })
    }

    const tableConfig = {
        data: customerPlateAwardsList,
        controls: [
            <Button roles={userRoles.editProducts} onClick={addPlateAward}>Assign Award</Button>
        ],
        headers: [
            {label: 'Award Name'},
            {label: 'Message'},
            {label: 'Priority'},
            {label: 'Expires'},
            {label: 'Date Viewed'},
            {label: 'Redeemed'}
        ],
        renderFormat: (e) => (
            <ManagementRow 
                key={generateId()}
                controls={renderActionButtons(e)}
                layout='elipsis'
            >
                <td>{e.awardName}</td>
                <td><div style={{postion: 'relative'}}>{e.message}</div></td>               
                <td>{e.priority}</td>
                <td>{e.expirationDate === undefined ? '' : shortHandDate(e.expirationDate)}</td>
                <td>{e.dateViewed === undefined ? '' : shortHandDateTimeUTC(e.dateViewed)}</td>
                <td>
                    <CheckMark checked={e.redeemed} />         
                </td>
            </ManagementRow>
        )
    }

    return (
        <RequireFeature requiredFeatures={Features.PlateReads}>
            <h4>Awards</h4>                
            <Table config={tableConfig} />
        </RequireFeature>
    );
}

export default CustomerPlateReadAwards;